export const isEnabledFlag = value => (
    value === true || value === 1 || value === '1' || value === 'true'
)

export const getNewUploadAuthorizerIds = (users, selectedUserIds) => {
    const selected = new Set((selectedUserIds || []).map(String))
    return (users || [])
        .filter(user => (
            selected.has(String(user.userId))
            && !isEnabledFlag(user.uploadAuthorized)
            && !isEnabledFlag(user.isOwner)
        ))
        .map(user => String(user.userId))
}

export const filterUploadAuthorizers = (users, keyword) => {
    const normalizedKeyword = String(keyword || '').trim().toLowerCase()
    if (!normalizedKeyword) return users || []
    return (users || []).filter(user => (
        [user.userNick, user.userName, user.userId]
            .some(value => String(value || '').toLowerCase().includes(normalizedKeyword))
    ))
}
